import { baseUrl, handleResponse, handleError, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "EligibleHours";

export function getForConsultant() {
  return fetch(apiUrl, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getForConsultant_Admin(userId) {
    return fetch(apiUrl + "/admin/" + userId, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
}

export function getForConsultant_Manager(userId) {
  return fetch(apiUrl + "/manager/" + userId, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}